import { utils, writeFile } from 'xlsx';

export function downloadXLSX(tableDataArray) {
	const worksheet = utils.json_to_sheet(tableDataArray);
	const workbook = utils.book_new();
	utils.book_append_sheet(workbook, worksheet, 'Sheet1');
	
	const filename = 'Records.xlsx';
	writeFile(workbook, filename);
  }

export function genericFirstCapitalLetter (value){
	if (!value) return ""
	let capitalize
	if (typeof(value)==="string"){
		capitalize = value.charAt(0).toUpperCase() + value.substring(1)
	} else {
		capitalize = value
	}
	return capitalize
}